import { lazy } from 'react';
import type { LazyExoticComponent, ComponentType } from 'react';

export interface DeckLessonDefinition {
  id: string;
  title: string;
  source: string;
  component: LazyExoticComponent<ComponentType>;
}

const deckLessonRegistry: Record<string, DeckLessonDefinition> = {
  'foundations-01': {
    id: 'foundations-01',
    title: 'The Old Model Is Breaking',
    source:
      'src/surfaces/deck/lessons/foundations-01/FoundationsLesson01Deck.tsx',
    component: lazy(() => import('./foundations-01/FoundationsLesson01Deck')),
  },
  'foundations-02': {
    id: 'foundations-02',
    title: 'What AI-Native Coaching Actually Is — And Why We Start With Acquisition',
    source:
      'src/surfaces/deck/lessons/foundations-02/FoundationsLesson02Deck.tsx',
    component: lazy(() => import('./foundations-02/FoundationsLesson02Deck')),
  },
  'foundations-01-remotion': {
    id: 'foundations-01-remotion',
    title: 'The Old Model Is Breaking (Remotion Experiment)',
    source:
      'src/surfaces/deck/lessons/foundations-01/FoundationsLesson01RemotionExperimentPage.tsx',
    component: lazy(() => import('./foundations-01/FoundationsLesson01RemotionExperimentPage')),
  },
};

export function getDeckLessonIds(): string[] {
  return Object.keys(deckLessonRegistry).sort();
}

export function getDeckLessonDefinition(
  lessonId: string,
): DeckLessonDefinition | null {
  return deckLessonRegistry[lessonId] ?? null;
}

export function getDeckLessonRoute(lessonId: string): string {
  return `?surface=deck&lesson=${lessonId}`;
}
